import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Tengo que comprar suplementos adicionales?',
  a: 'No. El protocolo se basa en cambios gratuitos de hábitos y elementos que ya tienes en casa.'
}, {
  q: '¿Cuánto tiempo me tomará leerlo?',
  a: 'Es directo al punto. Lo lees en 30 minutos y puedes empezar hoy mismo.'
}, {
  q: '¿Es una dieta tipo Keto o Vegana?',
  a: 'No es una dieta. Son ajustes biológicos que puedes aplicar independientemente de cómo comas.'
}, {
  q: '¿Necesito mucho tiempo al día para seguir el protocolo?',
  a: 'No. El protocolo está diseñado para personas ocupadas. La mayoría de los ajustes (como cambios en la hidratación o exposición a la luz) se integran en tu rutina actual y no te quitan más de 10 a 15 minutos extras al día.'
}, {
  q: '¿Es seguro si tengo alguna condición médica o tomo medicamentos?',
  a: 'El protocolo se basa en hábitos naturales y optimización biológica (luz, descanso y nutrición real). Sin embargo, siempre recomendamos consultar con tu médico antes de realizar cambios drásticos en tu estilo de vida, especialmente si estás bajo tratamiento médico.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-14 px-4 md:px-6 relative bg-[#0a0e1a]" data-id="element-29">
      <div className="max-w-3xl mx-auto" data-id="element-30">
        <FadeIn data-id="element-31">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-12" data-id="element-32">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-33">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-34">
              <div className={`border rounded-xl overflow-hidden transition-colors duration-300 ${openIndex === index ? 'border-cyan-500/50 bg-slate-800/50' : 'border-slate-700/50 bg-slate-800/20 hover:border-slate-600'}`} data-id="element-35">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-36">
                  <span className="font-semibold text-lg text-slate-200" data-id="element-37">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-cyan-400 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-38" />
                </button>
                <AnimatePresence data-id="element-39">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-40">
                      <div className="px-6 pb-5 text-slate-400" data-id="element-41">{faq.a}</div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}